import { useRouter } from 'next/router';
import { isMobile } from '@zep/utils';
import { PlanTemplateType, useStartPlanPayment } from '../../../../plan-payment';
import { getPricingAssetLocale } from '../../pricingAssetLocale';
export const OneTimePaymentBanner = () => {
  const {
    locale
  } = useRouter();
  const {
    handleStartPlanPayment
  } = useStartPlanPayment();
  const assetLocale = getPricingAssetLocale(locale);
  return <div className="flex w-full justify-center" data-sentry-component="OneTimePaymentBanner" data-sentry-source-file="OneTimePaymentBanner.tsx">
      <div className="flex h-[80px] w-full cursor-pointer items-center justify-center overflow-hidden bg-gradient-to-r from-[#D29AFF] via-[#9074FF] to-[#6D8FFF] lg:max-w-[1140px] lg:rounded-[8px]" onClick={() => {
      void handleStartPlanPayment({
        planType: 'pro',
        planTemplateType: PlanTemplateType.PRODUCT_ONETIME,
        onetimePeriod: '1M'
      });
    }}>
        <img src={`/images/pricing/${assetLocale}/${isMobile() ? 'banner_mobile' : 'banner_desktop'}.png`} alt="" width={530} height={80} />
      </div>
    </div>;
};